import React from "react";
import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom"; // Import useNavigate
import "./ArticlesCategories.scss";
import httpService from "../../common/http.service";

const ArticlesCategories = () => {
  const { i18n } = useTranslation();
  const language = i18n.language.toUpperCase();
  const navigate = useNavigate();
  const REACT_APP_ENDPOINT = process.env.REACT_APP_ENDPOINT;
  const url = `articlecategory?language=${language}&status=1`;

  const { data: categories, isLoading, isError } = useQuery(
    [`categories`, language],
    () => httpService.get(url).then((data) => data.data.data)
  );
  
  const DEFAULT_IMAGE = `${process.env.REACT_APP_IMG_URL}images/files-test/1734705843913.jpeg`;


  const handleCategoryClick = (categoryId) => {
    navigate(`/articles/${categoryId}`);
  };

  if (isLoading) {
    return <p>Loading categories...</p>;
  }

  if (isError) {
    return <p>Failed to load categories. Please try again later.</p>;
  }

  return (
    <div>
      <h2 className="mt-1 mb-3 text-center text-3xl text-[#f16334] font-poppins">Categories</h2>
      <div className="row g-3 mb-3">
        {categories &&
          categories.map((category, index) => (
            <div
              key={index}
              onClick={() => handleCategoryClick(category?._id)}
              className="col-4 col-lg-2 col-md-4  "
            >
              <div className="shadow-lg flex flex-col items-center justify-center w-full h-40 rounded-lg overflow-hidden border-1 border-gray-300">
                <div className="w-full h-32 overflow-hidden">
                  <img
                    alt="categories"
                    src={category.image || DEFAULT_IMAGE}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="w-full py-1 text-center flex items-center justify-center">
                  <h1 className=" text-sm  font-poppins truncate max-w-[calc(15ch)]">
                    {category.name}
                  </h1>
                </div>
              </div>
            </div>
          ))}
      </div>
    </div>
  );
};

export default ArticlesCategories;
